 /*
 Create By Sittikron : 12/06/2023
 Update By Sittikron : 9/08/2023  - เพิ่ม Permissionในการตรวจสอบ
 Update By Sittikron : 28/08/2023 - แก้ไขสิทธิทุกหน้า ที่เรียกการใช้  สิทธิ view  เปลี่ยนวิธีเขียนใหม่  ให้เหมือนหน้า m_project.js

 Update By POOM : 26/01/2024  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
 Update By POOM : 13/05/2024  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที

	
	
*/
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { Class_ETC_MsgError, 
        Class_ETC_MsgErrorfocusByID, 
        Class_ETC_MsgSuccess, 
        Class_ETC_Warning,
        BootstrapTooltip,
        Class_ETC_SessionTimeOut } from "../Class/Class_Etc";

import MsgDescription from "../Class/MsgDescription.json";
import ConfigETC from "../Class/ConfigETC.json";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PaginationActions from "../PartialView/PaginationActions";

import { CP_CheckPermission } from "../Class/Class_Permission";


function M_task() {

//#region #####################  Declare a variable       ###################

  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isSubtask, setIsSubtask] = useState(false);
  const [isAddorEditTask, setIsAddorEditTask] = useState(true);
  const [isAddorEditSubTask, setIsAddorEditSubTask] = useState(false);
  const [isAddorEditShowSubTask, setIsAddorEditShowSubTask] = useState("");
  const [isAddorEditSubTaskid, setIsAddorEditSubTaskid] = useState("-1");
  const [isAddorEditSubTaskName, setIsAddorEditSubTaskName] = useState("");
  const [RdoChargeorNone, setRdoChargeorNone] = useState("0");
  const [isAddorEditSubtasknonChargetype, setIsAddorEditSubtasknonChargetype] = useState("");
  const [isAddorEditShowTask, setIsAddorEditShowTask] = useState("");
  const [isAddorEditShowTaskname, setIsAddorEditShowTaskname] = useState("");
  const [isAddorEditShowTaskid, setIsAddorEditShowTaskid] = useState("-1");
  const [isAddorEditTasid, setIsAddorEditTaskid] = useState("-1");
  const [isAddorEditTaskName, setIsAddorEditTaskName] = useState("");
  const [isCheckclosesubtask, setIsCheckclosesubtask] = useState("");
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [isCount, setIsCount] = useState(0);
  const [issubCount, setIssubCount] = useState(0);
  const [listTask, setListTask] = useState([]);
  const [listSubTask, setListSubTask] = useState([]);
  const [listNoneChargeType, setlistNoneChargeType] = useState([]);
  const onChange_Radio = (e) => {
    setRdoChargeorNone(e.target.value)
  }

  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionDel, setIsPermissionDel] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);

  //#endregion

//#region #####################  Paging                   ###################

  const [page, setPage] = useState(0);
  // eslint-disable-next-line
  const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); //

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
  };

  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  
  const [page2, setPage2] = useState(0);
  // eslint-disable-next-line
  const [rowsPerPage2, setRowsPerPage2] = useState(ConfigETC.rowsPerPage); //

  const handleChangePage2 = (event, newPage2) => {
    setPage2(newPage2);
  };

  const handleChangeRowsPerPage2 = (event) => {
    setPage2(0);
  };

  //#endregion
  
//#region #####################  open on loead            ###################

  useEffect(() => {
    if (isFirst === true) {
      GetConfig();
      if (isLoadedConfigData === true) {     
        let ckpermission = CP_CheckPermission("master" , ["task_view"] , false , true)
        if (ckpermission === true) {
          setIsPermissionEdit(CP_CheckPermission("master" , ["task_edit"] , false , false))
          setIsPermissionDel(CP_CheckPermission("master" , ["task_delete"] , false , false))
          setIsPermissionAdd(CP_CheckPermission("master" , ["task_add"] , false , false))  
          BindList_Task("GET" ,function() {
            BindDDLType(function(){
              setIsFirst(false);
              setIsLoadProgress(false);
            });
          });
          }       
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadedConfigData]);
  
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  //#endregion

//#region #####################  Bind Data                ###################

  async function BindList_Task(isAct , _callback) {

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");

    var raw = "";

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    await fetch(configData.API_URL + "Task_Get", requestOptions)
      .then((response) => response.json())
      .then((result) => {

        if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else
        {

          if (result.total_Data > 0) {
            if (isAct === "DEL") {
              if (rowsPerPage * (page + 1) > result.total_Data) {
                let pagenow = Math.ceil(result.total_Data / rowsPerPage);
                setPage((pagenow === 0 ? 0 : pagenow - 1));
              }
            }
            else if (isAct === "GET") {
              setPage(0);
            }
            setListTask(result.data);
            setIsCount(result.total_Data);
            if (_callback != null) {
              _callback();
            }
          } else {
            setListTask([]);
            setIsCount(0);
            if (_callback != null) {
              _callback();
            }
          }
          
        }
      })
      .catch((error) => {
        setListTask([]);
        if (_callback != null) {
          _callback();
      }
      });
  }

  async function BindDDLType(_callback) {

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    var raw = JSON.stringify({
      "code_id": "1",
      "value_status": "1"
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    await fetch(configData.API_URL + "Datavalue_Get", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.total_Data > 0) {
          setlistNoneChargeType(result.data);
          if (_callback != null) {
            _callback();
          }
        } else {
          setlistNoneChargeType([]);
          if (_callback != null) {
            _callback();
          }
        }
       
      })
      .catch((error) => {
        setlistNoneChargeType([]);
        if (_callback != null) {
          _callback();
        }
      });
  };

  //#endregion

//#region #####################  Click Bind Subtask Data  ###################

  // function loopclear(_callback){
  //   for (let i = 0 ; i < listTask.length; i ++)
  //   {
  //     try  { document.getElementById("Line_Task_view" + (i+1).toString()).className = ""; }
  //     catch {  }
  //   }
  //   if (_callback != null) {
  //       _callback();
  //   }
  // }

  function onclick_view_Subtask(task_id,task_name) {

    setIsSubtask(true);
    setIsAddorEditShowTaskname(task_name);
    setIsAddorEditShowTaskid(task_id)
    setIsLoadProgress(true);
    Bind_Subtask("GET", task_id ,function() {
      setIsLoadProgress(false);
    });  

    setSelectedRowIndex(task_id);

    // loopclear(function () {
    //   const rowElement = document.getElementById("Line_Task_view" + rowindex.toString());
    //   if (rowElement) {
    //     rowElement.className="bg-secondary";
    //   }
    // });

  }
  
  async function Bind_Subtask(isAct, task_id , _callback) {
    try {

      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        task_id : task_id.toString()
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Tasksub_Getlist",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          if (isAct === "GET") {
            setPage2(0);
          } else if (isAct === "DEL"){
            if (rowsPerPage2 * (page2 + 1) > json.total_Data) {
              let pagenow = Math.ceil(json.total_Data / rowsPerPage2);
              setPage2(pagenow === 0 ? 0 : pagenow - 1);
            }
          }
          setListSubTask(json.data);
          setIssubCount(json.total_Data);          
          if (_callback != null) {
              _callback();
          }
        } else {
          setPage2(0);
          setListSubTask([]);
          setIssubCount(0);
          if (_callback != null) {
              _callback();
          }
        }
      }
      else
      {
        setPage2(0);
        setListSubTask([]);
        setIssubCount(0);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setPage2(0);
      setListSubTask([]);
      setIssubCount(0);
      if (_callback != null) {
          _callback();
      }
    }
  }

//#endregion

//#region #####################  delete Task Data         ###################

function Onclick_DeleteTask() {
  Class_ETC_Warning(MsgDescription.CFM002, DelTask);
};

function DelTask() {

  setIsLoadProgress(true);

  let token = localStorage.getItem("TStoken");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + token);
  var raw = JSON.stringify({
    "task_id": document.getElementById("hd_task_id").value.trim()
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch(configData.API_URL + "Task_Del", requestOptions)

    .then(response => response.json())
    .then(result => {
      if (result.status_ID === 1) {

        BindList_Task("DEL",function() {
          setIsLoadProgress(false);
          if(isAddorEditShowTaskid === isCheckclosesubtask)
          {setIsSubtask(false);}
          document.getElementById("modalTask_Close").click();
          Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
        });

      }
      else if (result.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        
        setIsLoadProgress(false);
        Class_ETC_MsgError(result.status_Desc, null);
        
      }
    })
    .catch(error => {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
    });
};

//#endregion

//#region #####################  delete SubTask Data      ###################

function Onclick_DeleteSubTask() {
  Class_ETC_Warning(MsgDescription.CFM002, DelSubTask);
};

function DelSubTask() {

  setIsLoadProgress(true);
  let token = localStorage.getItem("TStoken");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + token);
  var raw = JSON.stringify({
    "task_id": isAddorEditSubTaskid.toString(),
    "parent_id": isAddorEditShowTaskid.toString()
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch(configData.API_URL + "Tasksub_Del", requestOptions)

    .then(response => response.json())
    .then(result => {
      if (result.status_ID === 1) {

        BindList_Task("",function() {
          Bind_Subtask("DEL", isAddorEditShowTaskid ,function() {
            setIsLoadProgress(false);
            document.getElementById("close_Subtask").click(); 
            Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
          });
        });

      }
      else if (result.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        
        setIsLoadProgress(false);
        Class_ETC_MsgError(result.status_Desc, null);
        
        
      }
    })
    .catch(error => {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
    });
};

//#endregion

//#region #####################  Sorting Task Data        ###################

  function Onclick_Sorting_Task (Act, Task_id){

    setIsLoadProgress(true);

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);
    var raw = JSON.stringify({
      "task_id": Task_id.toString(),
      "act": Act.toString()
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(configData.API_URL + "Task_Sorting", requestOptions)

      .then(response => response.json())
      .then(result => {
        if (result.status_ID === 1) {
          
          BindList_Task("",function() {
            setIsLoadProgress(false);
          });
          
        }
        else if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else {
          
          setIsLoadProgress(false);
          Class_ETC_MsgError(result.status_Desc, null);
          
        }

      })
      .catch(error => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR002, null);
      });
  };

  //#endregion

//#region #####################  Sorting SubTask Data     ###################

function Onclick_Sorting_SubTask (Act, Task_id){

  setIsLoadProgress(true);

  let token = localStorage.getItem("TStoken");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + token);
  var raw = JSON.stringify({
    "task_id": Task_id.toString(),
    "parent_id": isAddorEditShowTaskid.toString(),
    "act": Act.toString()
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch(configData.API_URL + "Tasksub_Sorting", requestOptions)

    .then(response => response.json())
    .then(result => {
      if (result.status_ID === 1) {
        
        Bind_Subtask("", isAddorEditShowTaskid ,function() {
          setIsLoadProgress(false);
        });

      }
      else if (result.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        
        setIsLoadProgress(false);
        Class_ETC_MsgError(result.status_Desc, null);
        
      }
    })
    .catch(error => {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    });
};

//#endregion

//#region #####################  POPUP TASK               ###################

  function Onclick_Add_Edit_Task(Act, task_id, task_name) {

    setIsAddorEditTaskid(task_id);
    setIsAddorEditTaskName(task_name);
    setIsCheckclosesubtask(task_id);
    setIsAddorEditShowTask(Act);
    setIsAddorEditTask(true);   
  }
  //#endregion

//#region #####################  POPUP SAVE TASK          ###################

  function Onclick_SaveTask() {
    setIsLoadProgress(true);
    var isError = "";
    let txtError = "";

    if (document.getElementById("txt_task_name").value.trim() === "") 
    {
      txtError = "txt_task_name";
    }

    if (txtError !== "") {
      isError = "Empty";
    }

    if (isError !== "") 
    {
          setIsLoadProgress(false);
          Class_ETC_MsgErrorfocusByID( MsgDescription.ERR001, txtError);
    }
    else {
      SaveTask();
    }
  }

  async function SaveTask()
  {

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      let tn = document.getElementById("txt_task_name").value.trim();
      let td = document.getElementById("hd_task_id").value.trim();

      var raw;   

      if (isAddorEditShowTask === "Add")
      {
        raw = JSON.stringify({
          "task_name": tn,
        });
      }
      else
      {
        raw = JSON.stringify({
          "task_id": td,
          "task_name": tn,
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + (isAddorEditShowTask === "Add" ? "Task_Add" : "Task_Edit"),
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        
        BindList_Task("",function() {
          if(td.toString() === isAddorEditShowTaskid.toString())
          {setIsAddorEditShowTaskname(tn)}
          setIsLoadProgress(false);
          document.getElementById("modalTask_Close").click();
          setIsAddorEditTask(false);
          Class_ETC_MsgSuccess(MsgDescription.CFM001, null);
        });

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
        
    };
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }

  }
  //#endregion

//#region #####################  POPUP SUBTASK            ###################

  function Onclick_Add_Edit_SubTask(Act, task_id, task_name ,task_charge,task_nonCharge_type) {
    setIsAddorEditSubTaskid(task_id);
    setIsAddorEditSubTaskName(task_name);
    setRdoChargeorNone(task_charge.toString());
    setIsAddorEditSubtasknonChargetype(task_nonCharge_type);
    setIsAddorEditShowSubTask(Act);
    setIsAddorEditSubTask(true);
  }
  //#endregion

//#region #####################  POPUP SAVE TASK          ###################

   function Onclick_SaveSubTask() {
    setIsLoadProgress(true);
    var istxtError = "";
    let isError = "";

    if (document.getElementById("txt_subtask_name").value.trim() === "") {
      istxtError = "txt_subtask_name";
    }

    if (istxtError !== "") {
      isError = "Empty";
    }

    if (isError !== "") {
      if (isError === "Empty") {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError);
      }
    }
    else {    
      if (RdoChargeorNone !== "0" && 
          RdoChargeorNone !== "1" 
         )
      {
        setIsLoadProgress(false);            
        Class_ETC_MsgError(MsgDescription.ERR019 , null);
      }    
      else
      {
        SaveSubTask();
      }
    }   
  };
  async function SaveSubTask()
  {

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      let tid = isAddorEditShowTaskid;
      let stn = document.getElementById("txt_subtask_name").value.trim();
      let stid = document.getElementById("hd_subtask_id").value.trim();
      let stcn = RdoChargeorNone;
      let Ediit_ddlstct
      if(stcn === "1")
      {
         Ediit_ddlstct = "-1";
      }
      else 
      {
         Ediit_ddlstct = isAddorEditSubtasknonChargetype;
      }
      var raw;   

      if (isAddorEditShowSubTask === "Add")
      {
        raw = JSON.stringify({
          "parent_id": tid.toString(),
          "task_name": stn.toString(),
          "task_charge": stcn.toString(),
          "task_nonCharge_type": Ediit_ddlstct.toString()
        });
      }
      else
      {
        raw = JSON.stringify({
          "task_id": stid.toString(),
          "parent_id": tid.toString(),
          "task_name": stn.toString(),
          "task_charge": stcn.toString(),
          "task_nonCharge_type": Ediit_ddlstct.toString()
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + (isAddorEditShowSubTask === "Add" ? "Tasksub_Add" : "Tasksub_Edit"),
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {


        BindList_Task("",function() {
          Bind_Subtask("",isAddorEditShowTaskid,function() {
            setIsLoadProgress(false);     
            Class_ETC_MsgSuccess(MsgDescription.CFM001, null);
            document.getElementById("close_Subtask").click();
          });
        });
        
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
        
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }

  }
  //#endregion

  return (
    <>

      {isLoadProgress && (
        <div id="divLoadingProgress" name="divLoadingProgress" align="center" className="divWaiting" >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      
      <Helmet>
        <title>Task List</title>
      </Helmet>

      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="row">
            <div className="col-md-6  text-center">
              <div className="container-fluid">
                <h1 className="display-5"> <i className="fas fa-tasks" /> Task </h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                {/* SELECT2 EXAMPLE */}
                <div className="card shadow">
                  <div className="card-header ">
                    <h3 className="card-title">
                      Result <small> ({isCount}  items)</small>
                    </h3>
                    <div className="float-right">
                      <div className="btn-group">
                      {(isPermissionAdd === true) &&
                        <a href="#!" className="btn btn-primary btn-sm" title="AddTask" data-target="#modal-Task" data-toggle="modal" onClick={() => Onclick_Add_Edit_Task("Add","-1","")}>
                          <i className="fa fa-plus" /> Task
                        </a>
                      }
                      </div>
                    </div>
                  </div>
                  <div className="card-body p-0">
                  <TableContainer>
                      <Table className="table table-head-fixed  table-hover">
                      <TableHead>
                        <TableRow>
                          <TableCell style={{width: '3%'}}><b>#</b></TableCell>
                          <TableCell style={{width: '40%'}}><b>Task</b></TableCell>
                          <TableCell className="text-center" style={{width: '20%'}}><b>Sub task</b></TableCell>
                          <TableCell style={{width: '10%'}}><b>{isPermissionEdit === true ? "Sorting" : ""}</b></TableCell>
                          <TableCell style={{width: '10%'}} />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {(listTask.length === 0 && (
                                <TableRow key={1}>
                                  <TableCell colSpan={4} align="center">
                                    {ConfigETC.NoData}
                                  </TableCell>
                                </TableRow>
                              )) ||
                              listTask
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .map((row) => (
                        <TableRow 
                              id={"Line_Task_view" + row.task_id.toString()} 
                              key={row.task_id} 
                              className={selectedRowIndex === row.task_id ? "card bg-light-gray" : ""}
                        >
                          <TableCell>
                              <div className={selectedRowIndex === row.task_id ? "text-bold" : ""}>{row.rowindex}</div>
                              <input type="hidden" id="hd_Task_iddel" defaultValue={row.task_id}></input>
                          </TableCell>
                          <TableCell>
                            <div className={selectedRowIndex === row.task_id ? "text-bold" : ""}>
                              {row.task_name}
                            </div>
                          </TableCell>
                          <TableCell className="text-center align-top">
                            
                              {(row.cnt_subtask > 0 ?(
                                <div>
                                  {row.cnt_subtask}
                                </div>
                              ) :
                              (
                                <BootstrapTooltip title='Please fill in the "Sub task" for recording correct information of the "Time Sheet ".'>
                                  <i className="fas fa-exclamation-circle tip text-danger"></i>
                                </BootstrapTooltip>
                              )) }
                             
                          </TableCell>
                          <TableCell className="text-center align-top">
                          {(isPermissionEdit === true) &&
                            <div>
                              {(listTask.length === 1 && 
                               <div>
                               </div>
                              ) ||
                              (row.rowindex === 1 ? (
                                <div>
                                    <a href="#!" title="down" onClick={() => Onclick_Sorting_Task("down",row.task_id)} >
                                        <i className="fas fa-arrow-alt-circle-down fa-lg"></i>
                                    </a>
                                </div>
                                ) : row.rowindex === isCount ? (
                                  <a href="#!" title="up" onClick={() => Onclick_Sorting_Task("up",row.task_id)} >
                                    <i className="fas fa-arrow-alt-circle-up fa-lg"/>
                                  </a>
                                ) : (
                                <>
                                    <a href="#!" title="up" onClick={() => Onclick_Sorting_Task("up",row.task_id)} >
                                    <i className="fas fa-arrow-alt-circle-up fa-lg" />
                                    </a>
                                    <a href="#!" title="down" onClick={() => Onclick_Sorting_Task("down",row.task_id)}>
                                    <i className="fas fa-arrow-alt-circle-down fa-lg" />
                                    </a>
                                </>
                              ))}
                              </div>
                            }
                          </TableCell>
                          <TableCell className="text-right align-top">                                                        
                            <div className="btn-group btn-group-sm">
                              <a href="#!" className="btn btn-primary" title="EditTask" data-target="#modal-Task" data-toggle="modal" id="modalTask_open" onClick={function(){ Onclick_Add_Edit_Task("Edit",row.task_id,row.task_name);}}>
                                <i className="fas fa-pencil-alt" />
                              </a>
                              <a href="#!" className="btn btn-default" title="Subtask" onClick={() => onclick_view_Subtask(row.task_id,row.task_name)}><i className="fas fa-eye" /></a>
                            </div>
                          </TableCell>
                        </TableRow>
                        ))}                       
                      </TableBody>
                     </Table>
                    </TableContainer>
                    {listTask.length > 0 && (
                      <TablePagination
                        rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                        component="div"
                        count={listTask.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                       ActionsComponent={PaginationActions}
                      />
                    )}
                  </div>
                  {/* /.card-body */}
                </div>
                {/* /.card */}
              </div>

              {/*/////////////////////////////////////////////////////////// POPUP ADD OR EDIT TASK ///////////////////////////////////////////////////////////////////////////*/ }
              {isAddorEditTask && (
              <>
                <div className="modal fade" id="modal-Task">
                  <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">
                        <i className="fas fa-tasks" /> Task  
                        <span className="text-sm text-muted">({isAddorEditShowTask})</span>
                      </h4>
                      <button 
                        type="button"
                        id="modalTask_Close"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="form-horizontal">
                        <div className="form-group row">
                          <label className="text-sm col-sm-2 col-form-label">Task <span className="text-danger">*</span></label>
                          <div className="col-sm-10">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Task Name"
                                id="txt_task_name"
                                value={isAddorEditTaskName}
                                onChange={(e) => setIsAddorEditTaskName(e.target.value)}
                              />
                            <input type="hidden" id="hd_task_id" defaultValue={isAddorEditTasid}/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer justify-content-between">
                    {isAddorEditShowTask === "Edit" ? (
                          <div>
                              {(isPermissionDel === true) &&
                                  <button type="button" className="btn btn-default btn-sm" onClick={() => Onclick_DeleteTask()} >
                                    <i className="fas fa-trash-alt "/> Delete
                                  </button>
                              } 
                          </div>
                          )  : (
                          <>
                            <div></div>
                          </>
                      )}
                      {(isPermissionEdit === true) &&
                        <span className="float-right">
                          <button
                          type="button"
                          className="btn btn-primary"
                          onClick={Onclick_SaveTask}
                        >
                          <i className="fa  fa-save" /> Save
                        </button>
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </div>      
              </> 
              )}         
              {/*/////////////////////////////////////////////////////////// POPUP ADD OR EDIT TASK ///////////////////////////////////////////////////////////////////////////*/ }

              {isSubtask && (
              <>
              <div className="col-md-6">
                {/* SELECT2 EXAMPLE */}

                <div className="content-header">
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <div className="container-fluid">
                        <h4 className="display-5"> <i className="fas fa-tasks" /> Sub Task </h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="timeline">
                  <div className="time-label mb-0">
                    <span className="card bg-light-gray">{isAddorEditShowTaskname}</span>
                  </div>
                  <div>
                    <i className="fas fa-tasks bg-light-gray" />
                    <div className="timeline-item">
                      <div className="card  shadow">
                        <div className="card-header ">
                          <h3 className="card-title">
                            Result <small> ({issubCount}  items)</small>
                          </h3>
                          <div className="float-right">
                            <div className="btn-group">
                            {(isPermissionAdd === true) &&
                              <a href="#!" className="btn btn-primary btn-sm" title="AddTasksub" data-target="#modal-Tasksub" data-toggle="modal" onClick={function(){Onclick_Add_Edit_SubTask("Add","-1","","1","-1");}}>
                                <i className="fa fa-plus" /> Sub task
                              </a>
                            }
                            </div>
                          </div>
                        </div>
                        <div className="card-body p-0">
                          <TableContainer>
                            <Table className="table table-head-fixed  table-hover">
                            <TableHead>
                              <TableRow>
                                <TableCell style={{width: '3%'}}><b>#</b></TableCell>
                                <TableCell style={{width: '30%'}}><b>Sub task</b></TableCell>
                                <TableCell style={{width: '15%'}}><b>Charge</b></TableCell>
                                <TableCell style={{width: '10%'}}><b>{isPermissionEdit === true ? "Sorting" : ""}</b></TableCell>
                                <TableCell style={{width: '10%'}} />
                              </TableRow>
                            </TableHead>
                            <TableBody>
                            {(listSubTask.length === 0 && (
                            <TableRow key={1}>
                              <TableCell colSpan={5} align="center">
                                {ConfigETC.NoData}
                              </TableCell>
                            </TableRow>
                          )) ||
                            (listSubTask.length > 0 &&
                              listSubTask
                                .slice(
                                  page2 * rowsPerPage2,
                                  page2 * rowsPerPage2 + rowsPerPage2
                                )
                                .map((en) => (
                                <TableRow key={en.task_id}>
                                  <TableCell >
                                    <div>{en.rowindex}<input type="hidden" id="hd_SubTask_iddel" defaultValue={en.task_id}></input></div> 
                                  </TableCell>
                                  <TableCell>
                                    <div>{en.task_name}</div>
                                  </TableCell>
                                 <TableCell>
                                  <div>
                                      <span
                                          className={
                                              en.task_charge === 1
                                              ? ConfigETC.charge
                                              : ConfigETC.None_Charge
                                          }
                                          >
                                          {en.task_charge_str}
                                      </span>
                                  </div>
                                  <div><input type="hidden" id="hd_task_nonCharge_id" defaultValue={en.task_nonCharge_type}></input></div> 
                                  <div className="text-muted text-smaller d-none">{en.task_nonCharge_type_str}</div>
                                </TableCell>
                                <TableCell className="text-center  align-top  ">
                                <div className="btn-group btn-group-sm">
                                {(isPermissionEdit === true) &&
                                  <div>
                                    {
                                    (listSubTask.length === 1) ||
                                    (en.rowindex === 1 ? (
                                    <div>
                                        <a href="#!" title="down" onClick={() => Onclick_Sorting_SubTask("down",en.task_id)} >
                                            <i className="fas fa-arrow-alt-circle-down fa-lg"></i>
                                        </a>
                                    </div>
                                    ) : en.rowindex === issubCount  ? (
                                      <a href="#!" title="up" onClick={() => Onclick_Sorting_SubTask("up",en.task_id)}  >
                                        <i className="fas fa-arrow-alt-circle-up fa-lg"/>
                                      </a>
                                    ) : (
                                    <>
                                        <a href="#!" title="up" onClick={() => Onclick_Sorting_SubTask("up",en.task_id)} >
                                        <i className="fas fa-arrow-alt-circle-up fa-lg" />
                                        </a>
                                        <a href="#!" title="down" onClick={() => Onclick_Sorting_SubTask("down",en.task_id)} >
                                        <i className="fas fa-arrow-alt-circle-down fa-lg" />
                                        </a>
                                    </>
                                    ))}
                                  </div>
                                    }
                                </div>
                                </TableCell>
                                <TableCell className="text-right align-top  ">
                                  <div className="btn-group btn-group-sm">
                                    <a href="#!" className="btn btn-primary" title="EditTasksub" data-target="#modal-Tasksub" data-toggle="modal" onClick={function(){Onclick_Add_Edit_SubTask("Edit",en.task_id,en.task_name,en.task_charge,en.task_nonCharge_type);}}>
                                      <i className="fas fa-pencil-alt" />
                                    </a>
                                  </div>
                                </TableCell>
                              </TableRow>
                              )))}
                            </TableBody>
                          </Table>
                          </TableContainer>
                          {listSubTask.length > 0 && (
                            <TablePagination
                              rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                              component="div"
                              count={listSubTask.length}
                              rowsPerPage={rowsPerPage2}
                              page={page2}
                              onPageChange={handleChangePage2}
                              onRowsPerPageChange={handleChangeRowsPerPage2}
                              ActionsComponent={PaginationActions}
                            />
                          )}
                        </div>
                        {/* /.card-body */}
                      </div>
                      {/* /.card */}
                    </div>
                  </div>
                  <div>
                    <i className="far fa-clock bg-light-gray" />
                  </div>
                </div>
              </div>
              </>
            )}
            </div>
          </div>
        </section>
      </div>
      {/* /.content-wrapper */}

      {/*/////////////////////////////////////////////////////////// POPUP ADD OR EDIT SUBTASK ///////////////////////////////////////////////////////////////////////////*/ }
          {isAddorEditSubTask && (
              <>
                <div className="modal fade" id="modal-Tasksub">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title"><i className="fas fa-tasks" /> Sub Task  <span className="text-sm text-muted">{isAddorEditShowSubTask}</span></h4>
                        <button type="button" 
                                className="close" 
                                id="close_Subtask"
                                data-dismiss="modal" 
                                aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <div className="text-sm text-muted text-italic">Task </div>
                              <div className="input-group">
                                <h6>{isAddorEditShowTaskname}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="input-group">
                          <label className="text-sm">Sub Task <span className="text-danger">*</span> </label>
                          <div className="input-group">
                          <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Task Name"
                                id="txt_subtask_name"
                                value={isAddorEditSubTaskName}
                                onChange={(e) => setIsAddorEditSubTaskName(e.target.value)}
                              />
                            <input type="hidden" id="hd_subtask_id" defaultValue={isAddorEditSubTaskid}/>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group ">
                              <label>Charge</label>
                              <div className="form-group">
                              <div className="form-check">
                                <input type="radio" 
                                       id="rdo_Charges"
                                       value="1"
                                       name="rdo_Charge_or_None" 
                                       checked={RdoChargeorNone === "1"}
                                       onChange={(e) => onChange_Radio(e)}
                                />
                                <label htmlFor="rdo_Charges" className="form-check-label text-sm">
                                      &nbsp;Charge
                                </label>
                              </div>
                              <div className="form-check">
                                <input type="radio" 
                                       id="rdo_None_Charges"
                                       value="0"
                                       name="rdo_Charge_or_None" 
                                       checked={RdoChargeorNone === "0"}
                                       onChange={(e) => onChange_Radio(e)}
                                />
                                <label htmlFor="rdo_None_Charges" className="form-check-label text-sm">
                                      &nbsp;No charge
                                </label>
                                {RdoChargeorNone === "0" ? (
                                    <div className="d-none">
                                      <select className="form-control form-control-sm" 
                                              id="ddl_subtask_chargeType_Popup" 
                                              name="ddl_subtask_chargeType_Popup" 
                                              value={isAddorEditSubtasknonChargetype}
                                              onChange={(e) => setIsAddorEditSubtasknonChargetype(e.target.value)}
                                      >
                                          <option value={-1} >{ConfigETC.ddl_notspecified}</option>
                                          {
                                            listNoneChargeType.length > 0 &&
                                            listNoneChargeType.map((Type) =>
                                              <option key={Type.value_id} value={Type.value_id} >{Type.value_name}</option>
                                            )
                                          }
                                      </select>
                                    </div>
                                    )  : (
                                    <>
                                      <div className="form-control-sm">
                                      </div>
                                    </>
                                )}
                              </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer justify-content-between">
                        {isAddorEditShowSubTask === "Edit" ? (
                            <div>
                                {(isPermissionDel === true) &&
                                  <button type="button" className="btn btn-default btn-sm" onClick={() => Onclick_DeleteSubTask()}>
                                    <i className="fas fa-trash-alt " /> Delete
                                  </button>
                                }
                            </div>
                            )  : (
                            <>
                              <div></div>
                            </>
                        )}
                        {(isPermissionEdit === true) &&
                          <span className="float-right">
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => Onclick_SaveSubTask()}>
                              <i className="fa  fa-save" />  Save
                            </button>
                          </span>
                        }
                      </div>
                    </div>
                    {/* /.modal-content */}
                  </div>
                  {/* /.modal-dialog */}
                </div>
                </> 
              )}

      {/*/////////////////////////////////////////////////////////// POPUP ADD OR EDIT SUBTASK ///////////////////////////////////////////////////////////////////////////*/ }

    </>
  );
}

export default M_task;
